import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Vendor } from '../../services/vendor/vendor.model';
import { VendorService } from '../../services/vendor/vendor.service';
import { VendorFormComponent } from '../vendor-form/vendor-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AzureStorageService } from 'src/app/services/azure-storage/azure-storage.service';

@Component({
    selector: 'app-vendor-list',
    templateUrl: './vendor-list.component.html',
    styleUrls: ['./vendor-list.component.scss'],
})
export class VendorListComponent implements OnInit {
    dataSource = new MatTableDataSource<Vendor>([]);
    displayedColumns: string[] = ['name', 'shops', 'deleted', 'actions'];
    isLoading = true;
    isImporting = false;

    constructor(private vendorService: VendorService, private azureStorageService: AzureStorageService, private dialog: MatDialog, private snackBar: MatSnackBar) {}

    ngOnInit(): void {
        this.loadVendors();
        this.dataSource.filterPredicate = (data: Vendor, filter: string) => {
            return data.name.fr.toLowerCase().includes(filter);
        };
    }

    loadVendors(): void {
        this.isLoading = true;
        this.vendorService.getVendors().subscribe({
            next: (vendors) => {
                this.dataSource.data = vendors;
                this.isLoading = false;
            },
            error: (error) => {
                console.error('Error loading vendors', error);
                this.snackBar.open('Error loading vendors', 'Close', { duration: 3000 });
                this.isLoading = false;
            },
        });
    }
    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;

        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    openVendorForm(vendor?: Vendor): void {
        const dialogRef = this.dialog.open(VendorFormComponent, {
            width: '90%',
            maxWidth: '1200px',
            data: { vendor: vendor ? { ...vendor } : null },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.loadVendors();
            }
        });
    }

    deleteVendor(id: string): void {
        if (confirm('Are you sure you want to delete this vendor?')) {
            this.vendorService.deleteVendor(id).subscribe({
                next: () => {
                    this.snackBar.open('Vendor deleted successfully', 'Close', { duration: 3000 });
                    this.loadVendors();
                },
                error: (error) => {
                    console.error('Error deleting vendor', error);
                    this.snackBar.open('Error deleting vendor', 'Close', { duration: 3000 });
                },
            });
        }
    }

    async onFileSelected(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const file = input.files[0];

            // Validate file type
            if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
                this.snackBar.open('Please select a valid CSV file', 'Close', { duration: 3000 });
                return;
            }

            // Convert file to base64
            const base64Content = await this.azureStorageService.convertFileToBase64(file);
            const fileName = file.name;

            this.importVendorsFromCsv(fileName, base64Content);
        }
    }

    importVendorsFromCsv(fileName: string, fileContent: string): void {
        this.isImporting = true;

        this.vendorService.importVendorsFromCsv(fileName, fileContent).subscribe({
            next: (event) => {
                this.loadVendors(); // Refresh the list
                this.isImporting = false;
            },
            error: (error) => {
                console.error('Error importing vendors', error);
                this.snackBar.open('Error importing vendors: ' + (error.error?.message || 'Unknown error'), 'Close', { duration: 5000 });
                this.isImporting = false;
            },
        });

        // Reset the file input
        const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
        if (fileInput) fileInput.value = '';
    }

    downloadExampleCsv(): void {
        // Define the path to the example CSV file
        const exampleCsvUrl = 'assets/vendor-example.csv';

        // Create a link element
        const link = document.createElement('a');
        link.href = exampleCsvUrl;
        link.download = 'vendor-example.csv';

        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.snackBar.open('Example CSV file downloaded', 'Close', { duration: 3000 });
    }
}
